import type { CoworldUploadResponse } from "@softmax/observatory-client/types";
import { z } from "zod";

type PlayerCountBounds = {
  readonly min: number;
  readonly max: number;
};

const tokenBoundsSchema = z.object({
  game: z.object({
    config_schema: z.object({
      properties: z.object({
        tokens: z.object({ minItems: z.number(), maxItems: z.number() }),
      }),
    }),
  }),
});

export function playerCountBoundsFromManifest({
  manifest,
}: {
  readonly manifest: CoworldUploadResponse["manifest"];
}): PlayerCountBounds {
  const parsed = tokenBoundsSchema.safeParse(manifest);

  if (!parsed.success) {
    throw new Error("Coworld token schema must declare minItems and maxItems.");
  }

  const tokenSchema = parsed.data.game.config_schema.properties.tokens;
  const min = Math.max(1, tokenSchema.minItems);

  if (min > tokenSchema.maxItems) {
    throw new Error("Coworld token schema does not allow a player roster.");
  }

  return {
    min,
    max: tokenSchema.maxItems,
  };
}
